import { Case } from "@/types/workflow";
import { useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { CaseMobileCard } from "./mobile/CaseMobileCard";
import { CaseDesktopTable } from "./desktop/CaseDesktopTable";
import { motion, AnimatePresence } from "framer-motion";

interface CasesTableProps {
  cases: Case[];
  isLoading?: boolean;
  onEdit: (caseData: Case) => void;
  onDelete: (caseData: Case) => void;
  onViewWorkflow: (caseData: Case) => void;
  onCaseSelect?: (caseData: Case | null) => void;
}

export function CasesTable({ 
  cases, 
  isLoading, 
  onEdit, 
  onDelete, 
  onViewWorkflow,
  onCaseSelect 
}: CasesTableProps) {
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
  const isMobile = useIsMobile();

  const toggleDescription = (id: string) => {
    setExpandedRows(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  if (isLoading) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="p-4 text-center text-muted-foreground"
      >
        Laster saker...
      </motion.div>
    );
  }

  return (
    <AnimatePresence mode="wait">
      {isMobile ? (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="space-y-4"
        >
          {cases.map((caseData) => (
            <CaseMobileCard
              key={caseData.id}
              caseData={caseData}
              isExpanded={!!expandedRows[caseData.id]}
              onToggle={() => toggleDescription(caseData.id)}
              onEdit={() => onEdit(caseData)}
              onDelete={() => onDelete(caseData)}
              onViewWorkflow={() => onViewWorkflow(caseData)}
            />
          ))}
        </motion.div>
      ) : (
        <CaseDesktopTable
          cases={cases}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewWorkflow={onViewWorkflow}
        />
      )}
    </AnimatePresence>
  );
}